import axios from 'axios';
import { IGizmo, IUserV2 } from '../../types';

interface IParams {
  config?: IGizmo;
  context: {
    user?: IUserV2;
  };
}

/**
 * Initializataion function for FlowyFoundation
 *
 * @param {IGizmo} config RootGizmo configuration
 * @returns
 */
async function init({ config, context }: IParams) {
  const { user } = context;

  let jsonData: any | undefined;

  if (config?.ops?.form?.json?.urls?.get) {
    const { get: url } = config.ops.form.json.urls;

    if (user?.credentials) {
      const credentials: any = user.credentials;

      try {
        const response = await axios.get(url, {
          headers: {
            ...credentials,
          },
        });

        if (response.status === 200) {
          const { data } = response;

          if (data) {
            jsonData = data;
          }
        }
      } catch (e) {
        console.log('FoundationFunctions.init->e: ', e);
      }
    }
  }

  return {
    jsonData,
  };
}

export default init;
